import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, Redirect } from 'react-router-dom';
import Login from '../Login';
import ProtectedRoute from './ProtectedRoute';
import Subscriptions from '../Subscriptions';
import Payment from '../Payment';
import Plan from '../Business/SelectPremium';
import Business from '../Business';
import Download from '../Download';

Router.propTypes = {
  user: PropTypes.object,
};

function Router(props) {
  const { user } = props;

  return (
    <Switch>
      {/*<Route exact path="/" render={() => <Redirect to="/subscriptions" />} />*/}

      <Route exact path="/" component={Business} />
      <ProtectedRoute path="/subscriptions" component={Subscriptions} user={user} />

      <Route path="/plan" component={Plan} />
      <Route path="/payment" component={Payment} />
      <Route path="/download" component={Download} />

      <Route exact path="/login" component={Login} user={user} />
      <Redirect to="/" />
    </Switch>
  );
}

export default Router;



// WEBPACK FOOTER //
// ./src/containers/App/Router.js